import { Chip } from "@mui/material"

/**
 * One auth bundle an override names, on a list row.
 *
 * The bundle may have been deleted since the override was written, leaving the server with no
 * name for it. Falling back to the bare id is deliberate: the override genuinely still confers
 * whatever that bundle contains, so dropping the chip would understate the row.
 */
export function GrantBundleChip({ item: bundle, cy = "grant-bundle-chip" }) {
    return <Chip size="small" variant="outlined" label={`Bundle: ${bundle.name || bundle.id}`} data-cy={cy} />
}
